import { render, staticRenderFns } from "./EventoConfigurarImagen.vue?vue&type=template&id=32223792&"
import script from "./EventoConfigurarImagen.vue?vue&type=script&lang=js&"
export * from "./EventoConfigurarImagen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports